// Detail-page events shared by the Project / Phase / Unit-type detail pages
// (analytics sheet → the three "* Details Page" sections). Their bodies are
// identical apart from the entry_point, so one factory parameterised by the
// entry point replaces the old byte-for-byte trackProject*/trackPhase*/
// trackUnitType* families. The event name + entry_point stay baked in, so call
// sites still can't mislabel an event.
import {logAnalyticsEvent} from './analytics';
import type {AnalyticsEntryPoint, AnalyticsItemType} from './events';
import type {TrackedItem} from './shared';

export interface DetailPageAnalytics {
  gallery(item?: TrackedItem): void;
  registerInterest(item?: TrackedItem): void;
  takeTour(item: TrackedItem): void;
  map(item: TrackedItem): void;
  masterplan(item: TrackedItem): void;
  downloadBrochure(item: TrackedItem): void;
  carouselCard(item: TrackedItem, itemType: AnalyticsItemType): void;
  viewAll(item: TrackedItem, itemType: AnalyticsItemType): void;
  labelClick(item: TrackedItem): void;
}

export function detailAnalytics(entryPoint: AnalyticsEntryPoint): DetailPageAnalytics {
  return {
    gallery(item) {
      logAnalyticsEvent('gallery_click', {entry_point: entryPoint, item_id: item?.id, item_name: item?.name});
    },
    registerInterest(item) {
      logAnalyticsEvent('register_interest_click', {entry_point: entryPoint, item_id: item?.id, item_name: item?.name});
    },
    takeTour(item) {
      logAnalyticsEvent('take_a_tour', {entry_point: entryPoint, item_id: item.id, item_name: item.name});
    },
    map(item) {
      logAnalyticsEvent('map_click', {entry_point: entryPoint, item_id: item.id, item_name: item.name});
    },
    masterplan(item) {
      logAnalyticsEvent('masterplan_click', {entry_point: entryPoint, item_id: item.id, item_name: item.name});
    },
    downloadBrochure(item) {
      logAnalyticsEvent('download_brochure_click', {entry_point: entryPoint, item_id: item.id, item_name: item.name});
    },
    carouselCard(item, itemType) {
      logAnalyticsEvent('card_click', {entry_point: entryPoint, item_id: item.id, item_name: item.name, item_type: itemType});
    },
    viewAll(item, itemType) {
      logAnalyticsEvent('view_all_click', {entry_point: entryPoint, item_id: item.id, item_name: item.name, item_type: itemType});
    },
    labelClick(item) {
      logAnalyticsEvent('label_click', {entry_point: entryPoint, item_id: item.id, item_name: item.name});
    },
  };
}
